import { render, staticRenderFns } from "./ConfiAsesor.vue?vue&type=template&id=19e8e53a"
import script from "./ConfiAsesor.vue?vue&type=script&lang=js"
export * from "./ConfiAsesor.vue?vue&type=script&lang=js"
import style0 from "./ConfiAsesor.vue?vue&type=style&index=0&id=19e8e53a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports